import { LazyRouteFunction, NonIndexRouteObject } from 'react-router-dom';

export type NavigationConfig = {
  path: string;
  lazy?: LazyRouteFunction<NonIndexRouteObject>;
};

export const publicNavigationConfig: NavigationConfig[] = [
  {
    path: '/page/public/sign/:contactId/:contractId/:organizationId',
    lazy: async () => ({
      Component: (await import('../../pages/publicAccess/ContractSignPage')).default,
    }),
  },
  {
    path: '/page/public/sign/thankyou',
    lazy: async () => ({
      Component: (await import('../../pages/publicAccess/ThankYouForSigning')).default,
    }),
  },
];
